const style = `
  <style>
    :host {
      display: inline-block;
      position: relative;
      width: 100%;
      max-width: 300px;
    }
    
    .custom-select {
      position: relative;
      display: inline-block;
      font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      width: 100%;
      max-width: 300px;
    }

    .select-button {
      width: 100%;
      cursor: pointer;
      text-align: left;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: none;
      font-size: 24px;
      background: transparent;
      padding: 0px 10px 0px 0px;
      font-weight: 400;
      vertical-align: middle;
      color: #3BA590;
      outline: none;
    }

    .select-button:focus {
      outline: none;
      border: none;
    }

    .select-button::after {
      content: '';
      width: 18px;
      height: 18px;
      margin-left: 8px;
      transition: transform 0.3s ease;
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Chevron right'%3E%3Cpath id='Icon' d='M4 6L8 10L12 6' stroke='%234CBEA7' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .select-button[aria-expanded="true"]::after {
      transform: rotate(180deg);
    }

    .select-dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      margin: 0;
      padding: 0;
      list-style: none;
      background: #fff;
      display: none;
      z-index: 9999;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      min-width: 207px;
      pointer-events: auto;
    }

    .select-dropdown[aria-expanded="true"] {
      display: block !important;
    }

    .select-option {
      padding: 8px 12px;
      cursor: pointer;
      font-size: 20px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.28px;
      transition: background-color 0.2s ease;
    }

    .select-option:last-child {
      border-bottom: none;
    }

    .select-option:hover {
      background-color: #EFF9F7;
    }

    .select-option[aria-selected="true"] {
      display: none;
    }

    .select-option:focus {
      outline: none;
      background-color: #e9ecef;
    }

    .select-option[aria-selected="true"]:focus {
      background-color: #3daa94;
    }

    .hidden-select {
      display: none;
    }

    .select-label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }

    .select-wrapper {
      position: relative;
    }

    @media (max-width: 768px) {
      .custom-select {
        max-width: 100%;
      }
      
      .select-button {
        padding: 0px 14px;
        font-size: 26px;
      }
      
      .select-option {
        padding: 14px 16px;
        font-size: 16px;
      }
    }

    @media (min-width: 769px) {
      .select-button {
        font-size: 30px;
      }
      .select-button::after {
        width: 20px;
        height: 20px;
      }
    }

    /* Scrollbar styling */
    .select-dropdown::-webkit-scrollbar {
      width: 6px;
    }

    .select-dropdown::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    .select-dropdown::-webkit-scrollbar-thumb {
      background: #c1c1c1;
    }

    .select-dropdown::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  </style>
`;

export { style };
